// Shared Notetaker visibility predicates used across hooks, components, and features
// without creating feature-to-feature import cycles.

/** Statsig gate: on = new locale/tier/MSA gating active; off = pre-gating behavior. */
export const NOTETAKER_VISIBILITY_GATING_FLAG = 'notetaker_visibility_gating'

/**
 * Statsig gate for MSA org exclusion. Raw value `'off'` means MSA org — do not use `useFlag`
 * here; a missing gate must fail open to non-MSA.
 */
export const NOTETAKER_EXCLUDE_MSA_GATE = 'notetaker_exclude_msa'

/** True when the publisher user locale is English (case-insensitive prefix match). */
export const isEnglishLocale = (locale) => Boolean(locale?.toLowerCase().startsWith('en'))
